module.exports = __webpack_public_path__ + "img/wifi.13a514e4.svg";